import { axiosInstance as request } from '@api/rest.service'

const api = '/system-entity-label'

/**
 * @description GET /system-entity-label
 * @returns {AxiosPromise<any>}
 */
export const GET_ENTITY_LABELS = () => request.get(api)

/**
 * @description PATCH /system-entity-label/{id}
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_ENTITY_LABEL = (id, payload) => request.patch(`${api}/${id}`, payload)
